/**
 * @returns {string} - random string
 */
export const getUniqId = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

export function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

export function downloadBlob(url, filename) {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';

  a.href = url;
  a.download = filename;
  a.click();

  a.remove();
}
